<template>
  <AnalyticsWidget
    title="Stock Summary"
    subTitle="Summarised data for this stock item"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">

    <LoadingPanel :loading="loading" />
    <div v-if="!loading" class="p-2">
      <AnalyticsDashboardValueRow>
        <div class="col">
          <AnalyticsDashboardValue
            title="Average Sale Price"
            :value="averageSalePrice">
            <Spinner v-if="loadingSalesData" />
            <span v-if="!loadingSalesData">
              {{formatCurrency(averageSalePrice)}} / <span v-html="uomTypeDisplay"></span>
            </span>
            <template v-slot:info>Based on completed orders for the last 30 days</template>
          </AnalyticsDashboardValue>
        </div>
        <div class="col">
          <AnalyticsDashboardValue
            title="Total Units Sold"
            :value="totalUnitsSold">
            <Spinner v-if="loadingSalesData" />
            <span v-if="!loadingSalesData">
              <UOMValue :value="totalUnitsSold" :uomType="uomType" />
            </span>
            <template v-slot:info>Based on completed orders for the last 30 days</template>
          </AnalyticsDashboardValue>
        </div>
      </AnalyticsDashboardValueRow>
    </div>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

import { UOMTypeUnitsLookup } from '@/store/types'

export default {
  name: 'InventoryStockGlassServiceSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    filter: Object,
    stockId: Number,
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    averageSalePrice() {
      if(this.salesDetailedList.stocks) {
        let stockSalesInfo = this.salesDetailedList.stocks.find(stockSalesInfo => stockSalesInfo.id == this.stockId)
        if(stockSalesInfo) {
          return stockSalesInfo.avgSalePrice
        }
      }
      return 0
    },
    totalUnitsSold() {
      if(this.salesDetailedList.stocks) {
        let stockSalesInfo = this.salesDetailedList.stocks.find(stockSalesInfo => stockSalesInfo.id == this.stockId)
        if(stockSalesInfo) {
          return stockSalesInfo.totalUnits
        }
      }
      return 0
    },
    uomType() {
      if(this.salesDetailedList.stocks) {
        let stockSalesInfo = this.salesDetailedList.stocks.find(stockSalesInfo => stockSalesInfo.id == this.stockId)
        if(stockSalesInfo) {
          return stockSalesInfo.uomType
        }
      }
      return ''
    },
    uomTypeDisplay() {
      return this.formatLookupName(this.uomType, UOMTypeUnitsLookup)
    }
  },
  data() {
    return {
      loading: false,

      loadingSalesData: false,
      salesDetailedList: {}
    }
  },
  watch: {
    stockId: function() {
      this.requestData()
    }    
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      // Load sales data. Loaded seperately as this takes longer & we can display other data while waiting
      // Loads last 30 days of sales data
      var salesParams = {
        startDate: moment().local().subtract(30, 'days').startOf('day').toDate().toISOString(),
        endDate: moment().local().endOf('day').toDate().toISOString(),
        contactId: null,
        stockIdList: [this.stockId]
      }

      this.loadingSalesData = true
      this.$apiService.analyticsService.getOrdersValueServicesDetailedList(salesParams)
      .then(response => {
        this.salesDetailedList = response.data
      })
      .finally(() => {
        this.loadingSalesData = false
      })
    }
  }
}
</script>